import Notifications from 'react-notify-toast';
import React from 'react';
import { Grid, Header } from 'semantic-ui-react';

import CustomerForm from './form';

export default class Customer extends React.Component {
  render() {
    return (
      <Grid.Row>
      <Header as='h1'>Cadastro de Clientes</Header>
      <Notifications />
        <Grid.Column>
          <CustomerForm />
        </Grid.Column>
      </Grid.Row>)
  }
}